import React from 'react';
import { Package, Euro, Users, ShoppingBag, Boxes, AlertTriangle, Clock, Warehouse } from 'lucide-react';

const fmtEuro = (n) => (n || 0).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });

const StatCard = ({ label, value, icon: Icon, color, testId, hint }) => (
  <div className="bg-white rounded-sm border border-border p-6" data-testid={testId}>
    <div className="flex items-center justify-between mb-2">
      <h3 className="text-muted-foreground text-sm">{label}</h3>
      <Icon className={`w-7 h-7 ${color}`} />
    </div>
    <p className="text-3xl font-bold">{value}</p>
    {hint && <p className="text-xs text-muted-foreground mt-1">{hint}</p>}
  </div>
);

export const AdminStats = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold mb-3 text-muted-foreground uppercase tracking-wide">Ventes</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <StatCard label="Chiffre d'affaires" value={fmtEuro(stats.total_revenue)} icon={Euro} color="text-success" testId="stat-revenue" hint="Commandes payées" />
          <StatCard label="Commandes" value={stats.total_orders} icon={Package} color="text-brand-orange" testId="stat-orders" />
          <StatCard label="À expédier" value={stats.pending_orders} icon={Clock} color="text-blue-600" testId="stat-pending-orders" hint="Payées, non expédiées" />
          <StatCard label="Clients" value={stats.total_users} icon={Users} color="text-brand-orange" testId="stat-users" />
        </div>
      </div>
      <div>
        <h2 className="text-lg font-semibold mb-3 text-muted-foreground uppercase tracking-wide">État du stock</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <StatCard label="Valeur du stock" value={fmtEuro(stats.total_stock_value)} icon={Warehouse} color="text-success" testId="stat-stock-value" hint="Au prix de vente TTC affiché" />
          <StatCard label="Articles en stock" value={(stats.total_stock_units || 0).toLocaleString('fr-FR')} icon={Boxes} color="text-brand-dark" testId="stat-stock-units" hint={`${stats.total_products} références`} />
          <StatCard label="Stock faible" value={stats.low_stock} icon={AlertTriangle} color="text-yellow-600" testId="stat-low-stock" hint="5 unités ou moins" />
          <StatCard label="En rupture" value={stats.out_of_stock} icon={ShoppingBag} color="text-destructive" testId="stat-out-of-stock" />
        </div>
      </div>
    </div>
  );
};
